module.exports = __webpack_public_path__ + "img/number.71a23c73.svg";